import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { Rokojori } from "../Rokojori";
import { UserData } from "./RokojoriUser";
import { JSONHTMLTree } from "../../../library-js/json/JSONHTMLTree";
import { TemplatesList } from "../../templates/TemplatesList";
import { TimePin } from "../../../library-js/animation/TimePin";

export class PublicSessionData
{
  startTimestamp:string;
  activityTimestamp:string;
  userAgent:string;
  location:string;
}

export class UserDataValues
{
  email:string;
  sessions:PublicSessionData[];
}

export class UserDataValue
{
  static readonly type = new ElementType<HTMLElement>( "user-data" );
  static readonly noUserValue = new ElementAttribute( "no-user-value" );
  
  static readonly emails = new ElementAttribute( "email" );
  static readonly sessions = new ElementAttribute( "sessions" );

  static readonly userDataKey = new ElementType<HTMLElement>( "user-data-key" ); 
  static readonly userDataValue = new ElementType<HTMLElement>( "user-data-value" );
  static readonly userDataEntry = new ElementType<HTMLElement>( "user-data-entry" );
  static readonly userDataSession = new ElementType<HTMLElement>( "user-data-session" );

  static _userDataValues:HTMLElement[] = [];
  static _initialized = false;



  static applyOnDocument()
  {
    UserDataValue.initialize();
    this._userDataValues = [];
    UserDataValue.type.forAllInDoc( e => this.applyOnElement( e ) );
    
    this.loadData();
  }

  static initialize()
  {
    if ( UserDataValue._initialized )
    {
      return;
    }

    UserDataValue._initialized = true;

    Rokojori.$.userSystem.userID.addListener( 
      ()=> 
      {
        this.loadData();  
      }
    );
  }

  static applyOnElement( e:Element )
  { 
    this._userDataValues.push( e as HTMLElement );
  }

  static async loadData()
  {
    let userSystem = Rokojori.$.userSystem;

    this._userDataValues.forEach( e => this.setLoadingForElement( e ) );

    this._userDataValues.forEach( e => this.loadDataForElement( e ) );
  }

  static setLoadingForElement( e:Element )
  {
    let loaderRect = Rokojori.$.templatesManager.createTemplate( TemplatesList.LOADER_RECT );
    e.innerHTML = "";
    e.appendChild( loaderRect );
  } 

  static loadDataForElement( e:Element )
  {
    let userSystem = Rokojori.$.userSystem;

    if ( ! userSystem.isLoggedIn )
    {
      e.innerHTML = "-";

      if ( UserDataValue.noUserValue.in( e ) )
      {
        HTMLEditor.setText( e, UserDataValue.noUserValue.from( e ) );
      }

      return;
    }

    if ( UserDataValue.emails.in( e ) )
    {
      HTMLEditor.setText( e, userSystem._userData.email );
    }
    else if ( UserDataValue.sessions.in( e ) )
    {
      let sessions:any = {};
      e.innerHTML = "";
      
      for ( let i = 0; i < userSystem._userData.lastLogins.length; i++ )
      {
        sessions[ `#${i+1}`] = userSystem._userData.lastLogins[ i ];
      }

      e.appendChild( JSONHTMLTree.createFrom( sessions ) );
    }
  }

  
}